import * as React from "react";

export const READ_ONLY_EMPTY = "—";

interface ReadOnlyFieldProps {
    label: string;
    testId: string;
    children: React.ReactNode;
}

export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
    label,
    testId,
    children,
}) => (
    <div className="w-full min-w-0">
        {label ? <div className="mb-1">{label}</div> : null}
        <div
            data-testid={testId}
            className="form-input rounded-sm md:rounded w-full bg-gray-100 border-gray-300 text-gray-700">
            {children ?? READ_ONLY_EMPTY}
        </div>
    </div>
);
